import { Button, Grid, IconButton, Link, Typography, useTheme } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { getFileWeight } from "../utils/media-files";
import {ReactComponent as FileIcon} from '../assets/images/mi-portal/my-file/file.svg';
import {ReactComponent as TrashIcon} from '../assets/images/posts/trash-03.svg';
import { useRef, useState } from "react";
import DocumentViewer from "./DocumentViewer";

interface ListFilesToUploadProps {
    selectedFiles: File[];
    setSelectedFiles: (files: File[]) => void;
    buttonLabel: string;
    accept?: string;
    filesLimit?: number;
}

const ListFilesToUpload = ({selectedFiles, setSelectedFiles, buttonLabel, accept, filesLimit }: ListFilesToUploadProps) => {

    const theme = useTheme();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [urlFile, setUrlFile] = useState<string>("");
    // const [urlFileType, setUrlFileType] = useState<string>("");

    const handleTriggerButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;
        const newSelectedFiles: File[] = [];
        Array.from(files).forEach(file => {
            if (!selectedFiles.some((selectedFile) => selectedFile.name === file.name)) {
              newSelectedFiles.push(file);
            }
        });
        let allFiles = [...selectedFiles, ...newSelectedFiles];
        if (filesLimit && filesLimit < allFiles.length) {
            allFiles = allFiles.slice(0, filesLimit)
        }
        setSelectedFiles(allFiles);
    };

    const handleOpenFile = (fileData: File) => {
        if (fileData) {
          const blob = new Blob([fileData], { type: fileData.type });
          const blobURL = URL.createObjectURL(blob);
        //   window.open(blobURL, '_blank');
          setUrlFile(blobURL);
        //   setUrlFileType(fileData.type);
        } else {
          console.error('No file selected');
        }
    };

    return (
        <Grid item width={"100%"}>
            {selectedFiles && selectedFiles.map( (f, i) => ( 
                <Grid 
                    container 
                    direction="row"
                    justifyContent="space-between"
                    key={i}
                    alignItems="center"
                    style={{padding: "0.2rem 0"}}
                >
                    <Grid item>
                        <Grid 
                            container 
                            item 
                            direction="row"
                            alignItems="center"
                        >
                            <FileIcon />
                            <Typography variant="subtitle2" style={{color: theme.s10palette.S10Greygrey500, margin: "0 .25rem"}}>
                                <Link component="div" onClick={() => handleOpenFile(f)}>
                                    {f.name}
                                </Link>
                            </Typography> 
                            <Typography variant="body2" color={theme.s10palette.S10Greygrey500}>
                                {getFileWeight(f).sizeLabel}
                            </Typography> 
                        </Grid>
                    </Grid>
                    <Grid item>
                        <IconButton
                            size="small"
                            style={{
                                height: "2rem", 
                                width: "2rem", 
                            }}
                            onClick={() => {
                                const newFiles = [...selectedFiles];
                                newFiles.splice(i, 1);
                                setSelectedFiles(newFiles);
                            }}
                        >
                            <TrashIcon color="error" />
                        </IconButton>
                    </Grid>
                </Grid>)
            )}
            {(!filesLimit || filesLimit > selectedFiles.length) && <Button
                variant="outlined"
                style={{
                    backgroundColor: "white",
                    fontSize: "14px",
                }}
                startIcon={<AddIcon />}
                onClick={handleTriggerButtonClick}
            >
                {buttonLabel}
                
            </Button>}
            <input 
                type="file"
                ref={fileInputRef} 
                style={{ display: 'none' }}
                onChange={handleFileChange} 
                multiple 
                accept={accept ? accept : ".pdf,image/*"}
            />
            <DocumentViewer
                handleClose={() => {
                    setUrlFile("")
                    // setUrlFileType("");
                }}
                documentUrl={urlFile}
                // fileType={urlFileType}
            />
        </Grid>
    );
}

export default ListFilesToUpload;